module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "href": _vm.href
    },
    on: {
      "click": _vm.go
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-3de299b3!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/VLink.vue
// module id = 187
// module chunks = 2